import * as S from '../OfferLoader/OfferLoader.styles';

const OfferLoader = ({noBackGround}) => (
  <S.OfferLoaderWrapDiv noBackGround={noBackGround}>
    <S.offerInnerWrapDiv>
      <S.offerImageWrapDiv>
        <S.offerImageInnerWrapDiv></S.offerImageInnerWrapDiv>
        <S.OfferDeatilsWrapDiv>
          <S.OfferLoaderContextWrapDiv></S.OfferLoaderContextWrapDiv>
          <S.OfferLoaderContextWrapDiv></S.OfferLoaderContextWrapDiv>
          <S.ValidLoaderContextWrapDiv></S.ValidLoaderContextWrapDiv>
        </S.OfferDeatilsWrapDiv>
      </S.offerImageWrapDiv>
      {/* <S.AllOfferLoaderDiv></S.AllOfferLoaderDiv> */}
    </S.offerInnerWrapDiv>
  </S.OfferLoaderWrapDiv>
);

export default OfferLoader;
